import { gql } from '@apollo/client';

export const TOGGLE_SIP_SETTING_MUTATION = gql`
  mutation ToggleSipSettingMutation($input: ToggleSipSettingInput!) {
    toggleSipSetting(input: $input) {
      ID
      isEnabled
    }
  }
`;
